export default "//cloud.imgsmail.ru/cloud.mail.ru/183089/img/build/plus32-from-spherum.png";